export let getImage;
export let getSource;
export let getIcon;

export function setMedia(media) {
    getImage = media.getMediaImage;
    getSource = media.getSource;
    getIcon = media.getIcon;
}
